import createDomainListReduxUtil from '../../redux/utils/create-domain-list'

export const EXERCISE_FORM_CHECKS_DOMAIN = 'exerciseFormChecks'

export const EXERCISE_FORM_CHECKS_KEY = {
  ALL: 'all',
  DATA: 'data',
  CURRENT: 'current',
  HAS_SEEN_INTRO: 'hasSeenIntro'
}

export const EXERCISE_FORM_CHECKS_PATH = {
  ALL: `${EXERCISE_FORM_CHECKS_DOMAIN}.${EXERCISE_FORM_CHECKS_KEY.ALL}`,
  ALL_DATA: `${EXERCISE_FORM_CHECKS_DOMAIN}.${EXERCISE_FORM_CHECKS_KEY.ALL}.data`,
  DATA: `${EXERCISE_FORM_CHECKS_DOMAIN}.${EXERCISE_FORM_CHECKS_KEY.DATA}`,
  CURRENT: `${EXERCISE_FORM_CHECKS_DOMAIN}.${EXERCISE_FORM_CHECKS_KEY.CURRENT}`,
  HAS_SEEN_INTRO: `${EXERCISE_FORM_CHECKS_DOMAIN}.${EXERCISE_FORM_CHECKS_KEY.HAS_SEEN_INTRO}`
}

export const EXERCISE_FORM_CHECKS_STATE = {
  [EXERCISE_FORM_CHECKS_KEY.ALL]: createDomainListReduxUtil(),
  [EXERCISE_FORM_CHECKS_KEY.CURRENT]: null,
  [EXERCISE_FORM_CHECKS_KEY.HAS_SEEN_INTRO]: null,
  [EXERCISE_FORM_CHECKS_KEY.DATA]: {}
}

const ROOT = '/exercise-form-checks'
export const EXERCISE_FORM_CHECKS_ENDPOINT = {
  ROOT,
  BY_ID: `${ROOT}/:id`
}
